"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReactRouter = require("cccisd-react-router");
var _CurriculumMediator = _interopRequireDefault(require("./CurriculumMediator"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MediatorRoot = function MediatorRoot(ownProps) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Route, {
    path: "".concat(ownProps.match.url, "/:currentDeploymentId?"),
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_CurriculumMediator["default"], _extends({}, ownProps, {
        basePath: ownProps.match.url
      }));
    }
  });
};
var _default = (0, _cccisdReactRouter.withRouter)(MediatorRoot);
exports["default"] = _default;